import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function LitchfieldParkPage() {
  return <LocationPageTemplate city="Litchfield Park" cityShort="Litchfield Park" slug="litchfield-park" data-id="element-1015" />;
}